<template>
    <rkm-overlay>
        <rkm-layout-body :title="`Alto custo - ${id ? (data.additionals.permiteEdicao ? 'Edição' : 'Visualização') : 'Cadastro'} de processo`">
            <template v-slot:actions>
                <rkm-button
                    @click.stop="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <template v-if="data.additionals.permiteEdicao">
                    <rkm-button
                        @click="$refs.Form.save(true)"
                        color="primary"
                    >
                        Salvar e continuar
                    </rkm-button>

                    <rkm-button
                        v-if="data.additionals.permiteEdicao"
                        @click="$refs.Form.save(false)"
                        color="primary"
                    >
                        Salvar
                    </rkm-button>
                </template>
            </template>

            <rkm-layout-content>
                <Form
                    :key="formKey"
                    :id="id"
                    :paciente-id="pacienteId"
                    @data-load="data = $event"
                    @save="handleSave"
                    ref="Form"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/farmacia/alto-custo-gerenciamento-processo/Form'

// Others.
import { mapActions } from 'vuex'

export default {
    components: { Form },
    created() {

        this.setShowExitFormConfirmation()
    },
    data: () => ({
        formKey: 1,
        data: {
            additionals: { permiteEdicao: false }
        }
    }),
    methods: {
        ...mapActions(['setShowExitFormConfirmation', 'unsetShowExitFormConfirmation']),
        handleExit() {

            this.showExitConfirmation(async () => {

                this.unsetShowExitFormConfirmation()
                this.redirectToList()
            })
        },
        handleSave({ processo, continuarNaMesmaTela }) {

            if (continuarNaMesmaTela) {

                if (this.id) {

                    this.formKey++
                }
                else {

                    this.unsetShowExitFormConfirmation()
                    this.redirectToEdit(processo.pacienteId, processo.id)
                }
            }
            else {

                this.unsetShowExitFormConfirmation()
                this.redirectToList()
            }
        },
        redirectToList() {

            this.$router.push({ name: 'farmacia-alto-custo-gerenciamento-processo-index' })
        },
        redirectToEdit(pacienteId, id) {

            this.$router.push({
                name: 'farmacia-alto-custo-gerenciamento-processo-edit',
                params: { pacienteId, id }
            })
        }
    },
    props: {
        id: { type: Number, default: null },
        pacienteId: { type: Number, default: null },
    },
}
</script>